import { render } from "./agent.chats.conversation.vue?vue&type=template&id=2130ec46"
import script from "./agent.chats.conversation.vue?vue&type=script&lang=js"
export * from "./agent.chats.conversation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__